<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <router-link class="btn btn-sm btn-outline-info" :to="{ name: 'inventario-req_traslado_loc', params: {} }">
              <i class="fas fa-angle-double-left"></i>
              Atrás
            </router-link>
            <br><br>
            <div class="element-box">
              <h5 class="form-header">
                Requerimiento de Traslado Localización #{{ current.numero }}
                &nbsp; | &nbsp;
                <div class="badge" :class="{
                  'badge-success': current.estado == 'A',
                  'badge-warning': current.estado == 'B',
                  'badge-danger': current.estado == '9',
                }">
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{
                    current.estado_str
                    }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <button @click="refreshCurrent()" class="btn btn-md btn-info">
                      Actualizar Info. <i class="fas fa-sync"></i>
                    </button>
                    <button :disabled="current.estado == 'A'" class="btn btn-outline-dark" @click="imprimir(current.id)"
                      type="button">
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button :disabled="!current.id" aria-expanded="false" aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" type="button">
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                          type="button" :disabled="!(current.estado == 'B')" href="#">
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button class="dropdown-item" type="button" @click="cerrar" :disabled="!(current.estado == 'A')"
                          href="#">
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button class="dropdown-item" @click="anular" type="button" :disabled="!(current.estado != '9')"
                          href="#">
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
                current.errors.detail }}</small>
              <div class="row">
                <div class="col-sm-3">
                  <TiendaSelectComponent :current="current" />
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger': current.errors && current.errors.tipo,
                    }">Tipo</label>
                    <select class="form-control" autofocus="autofocus" v-model="current.tipo"
                      :disabled="current.estado != 'A'">
                      <option value="N">Reacomodo Devolución</option>
                      <option value="R">Reacomodo</option>
                      <option value="D">Reacomodo Devolucion</option>
                    </select>
                    <small v-if="current.errors && current.errors.tipo" class="form-text text-danger">{{
                      current.errors.tipo[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger': current.errors && current.errors.fecha,
                    }">Fecha</label>
                    <input v-model="fecha_str" class="form-control" placeholder="Fecha" :disabled="true" type="text" />
                    <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                      current.errors.fecha[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Usuario</label>
                    <input :disabled="true" class="form-control" v-model="current.usuario" type="text" />
                  </div>
                </div>
              </div>
              <div>
                <br />
                <button type="button" class="btn btn-sm btn-dark btn-block" @click="showModalAddDetail"
                  v-if="current.estado == 'A' && current.id">
                  <i class="fa fa-plus"></i>
                  Agregar Producto
                </button>
              </div>
              <br />
              <div class="table-responsive" v-if="current.id != null">
                <div class="text-right">
                  <span class="status-pill smaller green"></span>&nbsp;Abierta
                  <span class="status-pill smaller yellow"></span>&nbsp;Cerrada
                  <span class="status-pill smaller red"></span>&nbsp;Anulada
                </div>
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Producto</th>
                      <th class="text-center">Posición origen</th>
                      <th class="text-center">Posición destino</th>
                      <th class="text-center">Unidad Medida</th>
                      <th class="text-center">Cantidad</th>
                      <th class="text-center">Unidades</th>
                      <th class="text-center">Pendiente</th>
                      <th class="text-center">Total Pickeado</th>
                      <th class="text-center">Enviada</th>
                      <th class="text-center nowrap">Estado</th>
                      <th v-if="current.estado == 'A'" class="text-center">
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.reqtrasladolocd_set" v-bind:key="detalle.id">
                      <td>
                        <!--ProductoWithPopoverComponent :producto="detalle.producto" /-->
                        {{ detalle.producto.sku }}
                        <br />
                        <small>{{ detalle.producto.nombre }}</small>
                      </td>
                      <td class="text-center">
                        {{ detalle.posicion_origen }}
                      </td>
                      <td class="text-center">
                        {{ detalle.posicion_destino }}
                      </td>
                      <td>{{ detalle.unidad_medida.nombre }}</td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span class="text-success">+ {{ detalle.cantidad_um }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span class="text-success">+ {{ detalle.cantidad }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span v-bind:class="{
                          'text-danger': detalle.cantidad_abierta > '1',
                        }">{{ detalle.cantidad_abierta }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span style="color: #0032ff">{{
                          detalle.pickeado
                          }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span style="color: #0032ff">{{
                          detalle.enviada
                          }}</span>
                      </td>
                      <td class="text-center">
                        <span class="status-pill smaller green" v-if="detalle.estado == 'A'"></span>
                        <span class="status-pill smaller yellow" v-if="detalle.estado == 'B'"></span>
                        <span class="status-pill smaller red" v-if="detalle.estado == '9'"></span>
                      </td>
                      <td class="text-center" style="width: 200px" v-if="current.estado == 'A'">
                        <button class="btn btn-sm btn-danger mr-1" type="button" :disabled="current.estado == 'A' && !(detalle.estado == 'A')
                          " @click="deleteDetalle(detalle)">
                          <i class="fa fa-trash"></i>
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
              <div class="form-buttons-w">
                <button class="btn btn-md btn-success" v-if="current.estado == 'A'" @click="guardar()">
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqTraslado" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.length > 0,
                    }"></label>
                    <ProductoSelectComponentV2 @onChangeProducto="onChangeProducto" :current="currentDetalle">
                    </ProductoSelectComponentV2>
                    <small v-if="currentDetalle.errors" class="form-text text-danger">{{ currentDetalle.errors.detail
                      }}</small>
                  </div>
                </div>
                <div v-if="currentDetalle.producto && currentDetalle.producto.sku" class="col-sm-12">
                  <ProductoUnidadMedidaSelectComponent :current="currentDetalle.producto" />
                </div>
                <div v-if="currentDetalle.producto && currentDetalle.producto.sku" class="col-6">
                  <label>Posicion origen</label>
                  <select v-model="currentDetalle.posicion_origen" class="form-control">
                    <option v-for="det in posiciones" :value="det.posicion_id" :key="det.posicion_id">
                      {{ det.codigo_barra }}
                    </option>
                  </select>
                </div>
                <div v-if="currentDetalle.producto && currentDetalle.producto.sku" class="col-6">
                  <label>Posicion destino</label>
                  <select v-model="currentDetalle.posicion_destino" class="form-control">
                    <option v-for="det in posiciones" :value="det.posicion_id" :key="det.posicion_id">
                      {{ det.codigo_barra }}
                    </option>
                  </select>
                  <br />
                </div>
                <div class="col-sm-12" v-if="currentDetalle.producto && currentDetalle.producto.sku">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.cantidad_um &&
                        currentDetalle.errors.cantidad_um.length > 0,
                    }">Cantidad</label>
                    <input v-model="currentDetalle.cantidad_um" class="form-control" placeholder="Cantidad" type="text"
                      style="text-align: center; font-size: 200%" v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }" />
                    <small v-if="
                      currentDetalle.errors &&
                      currentDetalle.errors.cantidad_um
                    " class="form-text text-danger">{{ currentDetalle.errors.cantidad_um }}</small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle()">
              Agregar
            </button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoWithPopoverComponent from "@/components/commons/ProductoWithPopoverComponent";
import DynamicService from "@/services/commons/DynamicService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoWithPopoverComponent,
    ProductoSelectComponentV2,
  },
  data() {
    return {
      current: {
        estado_str: null,
        tienda: null,
        tienda_pedir: null,
        fecha: "01/01/2019",
        estado: "A",
        tipo: "-",
        errors: {
          tienda: "",
          fecha: "",
        },
        reqtrasladod_set: [],
      },

      unidades_medidas: [],
      productos: [],
      options: [],
      posiciones: [],

      currentDetalle: {
        cantidad: 0,
        cantidad_um: "",
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        a_pedir: null,
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    refreshDataPosiciones() {
      DynamicService.fetch("inv", "posiciones", {
        tienda: this.current.tienda,
        quitar_paginacion: true,
      }).then((response) => {
        this.posiciones = response.data;
      });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "inv",
        "req_traslado_loc",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda = response.data.tienda.codigo;
        self.current.tipo = response.data.tipo;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
        self.refreshDataPosiciones();
      });
    },
    refreshUnidadMedida(producto) {
      let self = this;
      ProductosService.getById(producto.sku).then((response) => {
        self.currentDetalle.producto = response.data;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.productounidadmedida_set[0];
        self.currentDetalle.producto.unidades_medidas =
          self.currentDetalle.producto.productounidadmedida_set;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.unidad_medida.unidad_medida.id;
      });
    },
    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      console.log(current);
      DynamicService.save("inv", "req_traslado_loc", current)
        .then((response) => {
          Notifications.alert.success(
            "Guardar información",
            "Realizádo Exitosamente"
          );
          if (current.id == null) {
            self.$router.push({
              name: "inventario-req_traslado_loc-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          Notifications.alert.error(
            "Guardar Requisiciones",
            error.response.data.detail
          );
        });
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },
    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),

    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqTraslado").modal();
      });
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
        det.unidad_medida = self.currentDetalle.producto.unidad_medida;
        DynamicService.postAction(
          "inv",
          "req_traslado_loc",
          self.current.id,
          "agregar_detalle",
          det
        )
          .then((response) => {
            Notifications.alert.success(
              "Requerimiento de Traslado",
              "Se ha guardado la Información."
            );
            self.refreshCurrent();
            self.refreshDetalleDefault();
            self.$refs.cerrarModal.click();
          })
          .catch((error) => {
            self.currentDetalle.errors = error.response.data;
          });
      }
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado Localización",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado_loc",
            detalle.req_traslado_loc_e,
            "eliminar_detalle",
            {
              id: detalle.id.replace("-", ""),
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado Localización",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;

              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Requerimiento de Traslado Localización",
                  error.response.data.detail
                );
              } else {
                if (error.response.data.salida_traslado_d) {
                  Notifications.alert.error(
                    "Requerimiento de Traslado Localización",
                    error.response.data.salida_traslado_d
                  );
                }
              }
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado Localización",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado_loc",
            self.current.id,
            "abrir"
          )
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado Localización",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "¡Información Importante!",
        "Si cierra la requisicion no podra abrirla nuevamente",
        "Si cerrar",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado_loc",
            self.current.id,
            "cerrar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado Localización",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado_loc",
            self.current.id,
            "anular"
          )
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    generar_movimiento_localizacion() {
      let self = this;
      Notifications.alert.confirm(
        "Generar transferencia de stock",
        "¿Esta seguro(a)",
        "Si, Generar",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado",
            self.current.id,
            "generar_transferencia_stock"
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar transferencia de stock",
                "Realizado Exitosamente"
              );
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Generar transferencia de stock",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    generar_salida() {
      let self = this;
      Notifications.alert.confirm(
        "Generar Salida de Producto a partir de un Requerimiento de Traslado",
        "¿Desea Generar una salida de bodega a partir de este requerimiento de traslado?",
        "Si, Generar",
        function () {
          ReqTrasladoService.generar_salida(self.current.id)
            .then((res) => {
              SalidaTrasladoService.getById(res.data.salida_traslado_e).then(
                (response) => {
                  self.current.salida = response.data;
                  Notifications.alert.success(
                    "Requerimiento de Traslado",
                    `salida Generada # ${self.current.salida.numero}`
                  );
                }
              );
              self.$router.push({
                name: "inventario-salida_traslado-editar",
                params: { id: res.data.salida_traslado_e },
              });
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshUnidadMedida(producto);
      self.refreshSugerido(producto);
    },
    refreshUnidadMedida(producto) {
      let self = this;
      ProductosService.getById(producto.sku).then((response) => {
        self.currentDetalle.producto = response.data;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.productounidadmedida_set[0];
        self.currentDetalle.producto.unidades_medidas =
          self.currentDetalle.producto.productounidadmedida_set;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.unidad_medida.unidad_medida.id;
      });
    },
    refreshSugerido(producto) {
      let self = this;
      self.currentDetalle.a_pedir = null;
      console.log(self.current);
      DynamicService.getActionList("inv", "req_traslado", "vw_a_pedir", {
        tienda: self.current.tienda_id,
        sku: producto.sku,
      }).then((response) => {
        if (response.data.length > 0) {
          console.log(response.data[0]);
          self.currentDetalle.a_pedir = response.data[0];
        }
      });
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: "",
        cantidad_um: "",
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        a_pedir: null,
        errors: [],
      };
    },
    imprimir(det) {
      det = det.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/Req_traslado_localizacion/Req_Traslado_localizacion.jrxml&id=${det}`
      );
    },
    productoClickSku(producto, e) {
      let content = "producto.nombre";
      $(event.target).popover({
        title: producto.sku,
        content: content,
        trigger: "focus",
        placement: "top",
      });
      $(event.target).popover("show");
    },
  },
};
</script>
